export const RESCTRICTED_ZIP_CODE_ERROR_CODE = '22.06';

export const CHECK_EXPOSURE_ERROR_CODE = '21.25';

export const BROKER_URLS = ['/xp', '/gallagher', '/coopercitrus'];